module.exports = __webpack_public_path__ + "img/icon_email2.985dfa9b.png";